import { Partial } from '@40seas/entities/common';
import { CreateConnectedAccountCurrencyConversionDto } from './create.connected-account.currency-conversion.dto';

export class UpdateConnectedAccountCurrencyConversionDto extends Partial(CreateConnectedAccountCurrencyConversionDto) {}
